import { AuthRoles } from '../../../config';
import { IAction, StateStatus } from '../../utils/common';
import * as Types from './types';

interface IUserData {
  username: string | null;
  email: string | null;
}
interface IState {
  login: boolean;
  status: string | null | undefined;
  role: number | null;
  token: string | null;
  refreshToken: string | null;
  stayLogin: boolean;
  data: IUserData;
  version: string | null;
}

const initialState: IState = {
  login: false,
  status: null,
  role: AuthRoles.Guest,
  token: null,
  refreshToken: null,
  stayLogin: false,
  data: {
    username: null,
    email: null,
  },
  version: null,
};

const AuthReducer = (state: IState = initialState, action: IAction): IState => {
  switch (action.type) {
    // AUTHENTICATE
    case Types.LOGIN_TYPE:
      return {
        ...state,
        login: action.status === StateStatus.Success,
        status: action.status,
        ...action.data,
      };
    case Types.LOGOUT_TYPE:
      return {
        ...state,
        ...initialState,
      };
    case Types.VERSION_TYPE:
      return {
        ...state,
        version: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};

export default AuthReducer;
